{
  "language-selection-dialog": {
    "buttons": {
      "close": "Zavřít"
    },
    "text": {
      "title": "Výběr jazyka",
      "hint": "Výběr jazyka, který se má zobrazit"
    }
  }
}
